import { render, staticRenderFns } from "./logistics.vue?vue&type=template&id=fdf11566&scoped=true&"
import script from "./logistics.vue?vue&type=script&lang=js&"
export * from "./logistics.vue?vue&type=script&lang=js&"
import style0 from "./logistics.vue?vue&type=style&index=0&id=fdf11566&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf11566",
  null
  
)

export default component.exports